export default function CoherentBookingFactory(
    $filter,
    DateFactory,
    bookingService,
    Bookings
) {
    var factory = this;

    factory.combinedBookings = [];
    /*
     * As last step before the user enters the booking flow, bookings that have coherent hours must be collected into one booking
     *
     * Important - For this feature to work bookingService.combinedBookngs must be send to server!!
     */
    factory.uniteBookings = function () {
        // First of all lets copy the bookings
        var orgBookings = angular.copy(Basket.currentBookings);

        // Add timestamp to each booking
        orgBookings = DateFactory.addTimestamps(orgBookings);

        // Distribut bookings into a new array called bookingsByLane
        var bookingsByLane = factory.uniteBookingsByLane(orgBookings);

        //Loops each Lane, Sorts by timestamp and finds coherent bookings
        //Return an array of new Booking Series
        var coherentBookings = factory.findCoherentBookings(bookingsByLane);

        // Combine the new coherent booking series
        //var coherentBookingCombiner =
        factory.coherentBookingCombiner(coherentBookings, orgBookings);

        // Finally remove the dublicate bookings from the original array of Booking and
        // returns an array, which is ready for the API to recieve
        factory.combinedBookings = factory.postCleanOrgBookingsArray(
            orgBookings
        );

        return factory.combinedBookings;
    };

    factory.postCleanOrgBookingsArray = function (orgBookings) {
        var dublicatesBookings = [];

        angular.forEach(orgBookings, function (booking) {
            if (booking.Periods.length > 1) {
                angular.forEach(booking.Periods, function (period) {
                    dublicatesBookings.push(period.UniqueKey);
                });
            }
        });

        angular.forEach(dublicatesBookings, function (periodID) {
            angular.forEach(orgBookings, function (booking, bookingIndex) {
                if (booking.Periods.length == 1) {
                    angular.forEach(booking.Periods, function (period) {
                        if (periodID == period.UniqueKey) {
                            orgBookings.splice(bookingIndex, 1);
                        }
                    });
                }
            });
        });

        return orgBookings;
    };

    factory.coherentBookingCombiner = function (coherentBookings) {
        var bookingCollections = [];

        angular.forEach(coherentBookings, function (lanes) {
            angular.forEach(lanes, function (lane) {
                var collectedBooking = {};

                angular.forEach(lane, function (booking, index) {
                    if (index == 0) {
                        collectedBooking = booking;
                    } else {
                        collectedBooking.Periods = collectedBooking.Periods.concat(
                            booking.Periods
                        );
                    }

                    if (index == lane.length - 1) {
                        collectedBooking.BookingEnd = booking.BookingEnd;
                        collectedBooking.ToDate = booking.ToDate;
                        collectedBooking.timeStampEnd = booking.timeStampEnd;
                    }
                });

                bookingCollections.push(collectedBooking);
            });
        });
        //console.log(bookingCollections);

        return bookingCollections;
    };

    factory.findCoherentBookings = function (bookingsByLane) {
        var allBookingSeries = [];

        angular.forEach(bookingsByLane, function (lane) {
            var coherentLaneBookingsCollection = [];

            // Sort by time
            lane.bookings = $filter("orderBy")(lane.bookings, "timeStampStart");

            var bookingSeries = [];

            var firstInCoherenceHasBeenAdded = false;
            var prevBooking = null;
            // var matchRound = false;

            angular.forEach(lane.bookings, function (booking, key) {
                if (prevBooking) {
                    if (prevBooking.timeStampEnd == booking.timeStampStart) {
                        if (!firstInCoherenceHasBeenAdded) {
                            // console.log('FIRST IN COHERENCE ADDED');
                            firstInCoherenceHasBeenAdded = true;

                            bookingSeries.push(prevBooking);
                        }

                        bookingSeries.push(booking);
                    } else {
                        // END OF COHERENCE SERIE

                        // deliver serie
                        if (bookingSeries.length) {
                            coherentLaneBookingsCollection.push(bookingSeries);
                        }
                        // reset
                        bookingSeries = [];

                        firstInCoherenceHasBeenAdded = false;
                    }
                }

                // if last iteration
                if (key == lane.bookings.length - 1) {
                    //do we have an ongoing serie in last iteration then push it (finish it).
                    if (bookingSeries.length) {
                        coherentLaneBookingsCollection.push(bookingSeries);
                    }
                }

                prevBooking = booking;
            });

            if (coherentLaneBookingsCollection.length) {
                allBookingSeries.push(coherentLaneBookingsCollection);
            }
        });

        return allBookingSeries;
    };

    factory.uniteBookingsByLane = function (orgBookings) {
        var lanesArray = [];

        // Loop all bookings
        angular.forEach(orgBookings, function (booking) {
            // create a lane obj
            var oLane = {
                LaneID: booking.LaneID,
                bookings: [],
            };

            var i;
            var found = false;

            // Inner loop to examine where in the lanesArray ( match by LaneID )
            for (i = 0; i < lanesArray.length; i++) {
                if (lanesArray[i].LaneID == booking.LaneID) {
                    found = true; // Mark as found in LanesArray
                    break;
                }
            }

            if (found) {
                // Add To Lanes Array - // remembers i from inner loop
                lanesArray[i].bookings.push(booking);
            } else {
                // Npt found - push the oLane Object
                oLane.bookings.push(booking);
                lanesArray.push(oLane);
            }
        });

        return lanesArray;
    };

    return factory;
}
